import type { User } from '@homeviews/models'
import { api } from '../api'

export interface UserResponse {
  access_token: string
}

export interface LoginRequest {
  username: string
  password: string
}

const formData = new FormData()
formData.append('grant_type', 'password')
formData.append('client_id', process.env.NX_CLIENT_ID)
formData.append('client_secret', process.env.NX_CLIENT_SECRET)

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<UserResponse, LoginRequest>({
      query: (credentials) => {
        formData.append('password', credentials.password)
        formData.append('username', credentials.username)

        return {
          url: `${process.env.NX_API_BASE_URL_PREFIX}/oauth/token`,
          method: 'POST',
          body: formData,
        }
      },
    }),
    resetPassword: builder.mutation({
      query: ({ data }) => {
        return {
          url: `/reset-password`,
          method: 'POST',
          body: data,
        }
      },
    }),
    confirmResetPassword: builder.mutation({
      query: ({ data, token }) => {
        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)

        return {
          url: `/reset-password/${token}`,
          method: 'POST',
          body: {
            ...data,
            ll: urlParams.get('ll'),
          },
        }
      },
    }),
    getUser: builder.query<User, void>({
      query: () => ({
        url: '/authn/whoami',
      }),
      providesTags: <any>['Auth'],
    }),
    protected: builder.mutation<any, void>({
      query: () => '/authn/whoami',
    }),
    signOut: builder.mutation<void, void>({
      query: () => ({
        url: '/authn/sign-out',
        method: 'POST',
      }),
    }),
    updateUser: builder.mutation({
      query: ({ data }) => {
        return {
          url: 'user',
          method: 'POST',
          body: data,
        }
      },
      invalidatesTags: <any>['Auth'],
    }),
  }),
})

export const {
  useLoginMutation,
  useProtectedMutation,
  useGetUserQuery,
  useUpdateUserMutation,
  useResetPasswordMutation,
  useConfirmResetPasswordMutation,
  useSignOutMutation,
} = authApi
